import * as Yup from 'yup'

export const phoneValidator = Yup.string().matches(
  /^\d{2}\s+\d{4,5}-\d{4}$/g,
  'Celular Inválido'
)
